import React, { createContext, useContext, useState, useEffect } from "react";
import { getAllBubbleData } from "../services/api/NotificationsApi";

const BubbleSettingsContext = createContext();

export const BubbleSettingsProvider = ({ children }) => {
  const [bubbleSettings, setBubbleSettings] = useState(() => {
    const stored = localStorage.getItem("bubbleSettings");
    return stored ? JSON.parse(stored) : null;
  });

  const fetchAndUpdateBubbleSettings = async () => {
    try {
      const bubbleRes = await getAllBubbleData();
      localStorage.setItem("bubbleSettings", JSON.stringify(bubbleRes.data));
      setBubbleSettings(bubbleRes.data);
    } catch (error) {
      console.error("Failed to fetch bubble settings:", error);
    }
  };

  useEffect(() => {
    fetchAndUpdateBubbleSettings(); 
  }, []);

  return (
    <BubbleSettingsContext.Provider
      value={{ bubbleSettings, setBubbleSettings, fetchAndUpdateBubbleSettings }}
    >
      {children}
    </BubbleSettingsContext.Provider>
  );
};

export const useBubbleSettings = () => useContext(BubbleSettingsContext);
